import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { findIndex, indexOf } from 'lodash';

import { RadioTypesEnum } from '../../../../Common/Forms/enums/radio-types.enum';
import { NetworkTypeEnum, networkOptionsOrder } from '../../../Core/enums/network-type.enum';
import { socialMediaTypeImageMap, MediaTypeEnum } from '../../../../Common/Basic/enums/media-type.enum';

export interface NetworkOption {
    type: NetworkTypeEnum;
    icon?: string;
    iconImageUrl?: string;
    disabled?: boolean;
    tooltip: string;
    isPartiallyModerated?: boolean;
}

@Component({
    selector: 'agpr-network-radio',
    templateUrl: './network-radio.component.html',
    styleUrls: ['./network-radio.component.scss'],
    standalone: false
})
export class NetworkRadioComponent implements OnInit {

    @Input() set availableNetworks(availableNets: NetworkTypeEnum[]) {
        // if the account has access to tiktok, to include it in network radio buttons
        if (availableNets.length && availableNets.includes(NetworkTypeEnum.tiktok)) {
            // we only want to add it if it doesn't exist already
            if (findIndex(this.networkOptions, (mediaTypeOption) => {
                return mediaTypeOption?.type === NetworkTypeEnum.tiktok;
            }) === -1) {
                this.networkOptions.push(this.tiktokOption);
            }
            // we want to sort the other of the network radio buttons
            this.networkOptions.sort((a, b) => {
                return indexOf(networkOptionsOrder, a.type) - indexOf(networkOptionsOrder, b.type);
            });
        }

        this.networkOptions.forEach(networkType => {
            const validNetwork = availableNets.find(x => x === networkType.type);
            networkType.disabled = !validNetwork;
        });

        if (this.selectedSocialNetwork !== null && !availableNets?.includes(this.selectedSocialNetwork?.type)) {
            for (const networkOption of this.networkOptions) {
                if (!networkOption.disabled) {
                    this.selectedSocialNetwork = networkOption;
                    this.selectedNetwork.emit(this.selectedSocialNetwork.type);
                    break;
                }
            }
        }
    }

    @Input() id: string;
    @Input() defaultSelection: NetworkTypeEnum;
    @Input() showAllOption: boolean = true;
    @Input() showDisabledOptions: boolean = true;
    @Input() heading: string;
    @Input() showReddit: boolean = true;
    @Input() ariaLabel: string;

    @Output() selectedNetwork: EventEmitter<NetworkTypeEnum> = new EventEmitter<NetworkTypeEnum>();

    selectedSocialNetwork: NetworkOption = null;

    networkOptions: NetworkOption[] = [
        {
            type: NetworkTypeEnum.all,
            iconImageUrl: 'assets/images/all_logo.png',
            disabled: false,
            tooltip: 'Social.network.all'
        },
        {
            type: NetworkTypeEnum.twitter,
            iconImageUrl: socialMediaTypeImageMap.get(MediaTypeEnum.TWITTER),
            disabled: true,
            tooltip: `MediaType.${MediaTypeEnum.TWITTER}`
        },
        {
            type: NetworkTypeEnum.facebook,
            iconImageUrl: socialMediaTypeImageMap.get(MediaTypeEnum.FACEBOOK),
            disabled: true,
            tooltip: `MediaType.${MediaTypeEnum.FACEBOOK}`
        },
        {
            type: NetworkTypeEnum.instagram,
            iconImageUrl: socialMediaTypeImageMap.get(MediaTypeEnum.INSTAGRAM),
            disabled: true,
            tooltip: `MediaType.${MediaTypeEnum.INSTAGRAM}`
        },
        {
            type: NetworkTypeEnum.youtube,
            iconImageUrl: socialMediaTypeImageMap.get(MediaTypeEnum.YOUTUBE),
            disabled: true,
            tooltip: `MediaType.${MediaTypeEnum.YOUTUBE}`
        },
        {
            type: NetworkTypeEnum.reddit,
            iconImageUrl: socialMediaTypeImageMap.get(MediaTypeEnum.REDDIT),
            disabled: true,
            tooltip: `MediaType.${MediaTypeEnum.REDDIT}`
        },
        {
            type: NetworkTypeEnum.linkedin,
            iconImageUrl: socialMediaTypeImageMap.get(MediaTypeEnum.LINKEDIN),
            disabled: true,
            tooltip: `MediaType.${MediaTypeEnum.LINKEDIN}`
        },
        {
            type: NetworkTypeEnum.bluesky,
            iconImageUrl: socialMediaTypeImageMap.get(MediaTypeEnum.BLUESKY),
            disabled: true,
            tooltip: `MediaType.${MediaTypeEnum.BLUESKY}`
        }
    ];

    tiktokOption: NetworkOption = {
        type: NetworkTypeEnum.tiktok,
        iconImageUrl: socialMediaTypeImageMap.get(MediaTypeEnum.TIKTOK),
        disabled: true,
        tooltip: `MediaType.${MediaTypeEnum.TIKTOK}`
    };

    readonly radioTypesEnum = RadioTypesEnum;

    constructor() {}

    ngOnInit() {
        if (!this.showAllOption) {
            this.networkOptions = this.networkOptions.filter(network => network.type !== NetworkTypeEnum.all);
        }

        if (!this.showReddit) {
            this.networkOptions = this.networkOptions.filter(network => network.type !== NetworkTypeEnum.reddit);
        }

        if (!this.showDisabledOptions) {
            this.networkOptions = this.networkOptions.filter(network => network.disabled === false);
            this.tiktokOption.disabled = false;
        }

        if (this.defaultSelection) {
            const newDefault = this.networkOptions.find(network => network.type === this.defaultSelection);
            if (newDefault) {
                this.selectedSocialNetwork = newDefault;
            }
        } else {
            this.selectedSocialNetwork = this.networkOptions[0];
        }
    }
}
